import React from "react"
import { Col, Row } from "reactstrap"
import { T } from "../../traks"
import { site_name } from '../../Site';

export const PremiumInfo = () => {
    return (
        <React.Fragment>
            <Row className="mt-4">
                <Col>
                    <h2><T>Why choose premium on {site_name}</T></h2>
                </Col>
            </Row>

            <Row className="mt-5">
                <Col sm="5">
                    <img className="premium-rounded-corners premium-info-img" width="100%" height="100%" src="https://static.aktiedysten.dk/imgs/Screenshot-13-768x432-1.jpg" alt="Two trophies on a table in a room full of blurred people" />
                </Col>
                <Col sm="7">
                    <Row>
                        <Col>
                            <h3><T>Play with as many participants as you want</T></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span><T>With premium, you choose how many people you’d like to be able to invite to your game. Once you've selected your number above, you'll then have the opportunity to create games with more than 30 participants.</T></span>
                        </Col>
                    </Row>
                    <Row className="premium-double-img-container">
                        <Col sm="6" className="d-flex flex-column align-items-center mt-3 premium-single-img-container h-100" >
                            <img width="150px" height="150px" src="https://static.aktiedysten.dk/gfx/13-300x300.png" alt="A cartoon hand interacts with a slider, setting it to '30'" />
                            <b className="pt-1 fw_800"><T>Standard</T></b>
                            <p className="text-center flex-grow-1 d-flex align-items-center"><T>Play with up to 30 participants</T></p>
                        </Col>
                        <Col sm="6" className="d-flex flex-column align-items-center mt-3 premium-single-img-container h-100" >
                            <img width="150px" height="150px" src="https://static.aktiedysten.dk/gfx/14-300x300.png" alt="A cartoon hand interacts with a slider, setting it to '147'" />
                            <b className="pt-1 fw_800"><T>Premium</T></b>
                            <p className="text-center flex-grow-1 d-flex align-items-center"><T>You decide how many participants to invite</T></p>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row className="mt-5 pt-5">
            <Col sm="7">
                    <Row>
                        <Col>
                            <h3><T>Possibility for greater diversification</T></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span><T>Expanding to include more markets on {site_name} gives participants the possibility to achieve greater diversification in their portfolio.</T></span>
                        </Col>
                    </Row>
                    <Row className="premium-double-img-container">
                        <Col sm="6" className="d-flex flex-column align-items-center mt-3 premium-single-img-container h-100" >
                            <img width="150px" height="150px" src="https://static.aktiedysten.dk/gfx/Billede1-295x300.png" alt="A green shopping cart icon with a Danish flag-like design on the inside of the cart, on a light green background." />
                            <b className="pt-1 fw_800"><T>Standard</T></b>
                            <p className="text-center flex-grow-1 d-flex align-items-center"><T>1 stock market per game</T></p>
                        </Col>
                        <Col sm="6" className="d-flex flex-column align-items-center mt-3 premium-single-img-container h-100" >
                            <img width="150px" height="150px" src="https://static.aktiedysten.dk/gfx/Billede2-300x300.png" alt="A green shopping cart filled with various items representing global investments, including oil, ETF, and flags of different countries, symbolizing international markets." />
                            <b className="pt-1 fw_800"><T>Premium</T></b>
                            <p className="text-center flex-grow-1 d-flex align-items-center"><T>Stocks, bonds, ETFs, funds, and indices from the Danish, Swedish, US, German, Finnish, and Icelandic markets, as well as selected commodities</T></p>
                        </Col>
                    </Row>
                </Col>
                <Col sm="5">
                    <img className="premium-rounded-corners premium-info-img" width="100%" height="100%" src="https://static.aktiedysten.dk/imgs/1-5-768x432.jpg" alt="Open laptop displaying financial data, including charts and graphs" />
                </Col>
            </Row>

            <Row className="mt-5 pt-5">
                <Col sm="5">
                    <img className="premium-rounded-corners premium-info-img" width="100%" height="100%" src="https://static.aktiedysten.dk/imgs/IMG_7898-768x576.jpg" alt="Students celebrating a school stock market competition win" />
                </Col>
                <Col sm="7">
                    <Row>
                        <Col>
                            <h3><T>Possibility to make risk visible</T></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span><T>Each stock has a risk score that participants can use to evaluate it. This score can also be used to rank participants on the leaderboard, where the ability to balance risk and return determines the winner.</T></span>
                        </Col>
                    </Row>
                    <Row className="premium-double-img-container">
                        <Col sm="6" className="d-flex flex-column align-items-center mt-3 premium-single-img-container h-100" >
                            <img width="150px" height="150px" src="https://static.aktiedysten.dk/gfx/Billede3.png" alt="A stylized, pink figure running or moving quickly, surrounded by a light green circle and various graphic elements, including growth charts and speed lines.  The graphic conveys a sense of progress, achievement, and movement" />
                            <b className="pt-1 fw_800"><T>Standard</T></b>
                            <p className="text-center flex-grow-1 d-flex align-items-center"><T>Winner based on returns</T></p>
                        </Col>
                        <Col sm="6" className="d-flex flex-column align-items-center mt-3 premium-single-img-container h-100" >
                            <img width="150px" height="150px" src="https://static.aktiedysten.dk/gfx/Billede4.png" alt="A stylized illustration of a person working on math problems.  The figure is magenta, and is surrounded by various math symbols, such as plus, minus, multiplication, and division signs, all in various shades of pink, and floating in speech bubbles.  The person is writing in a notepad. The background is a light lime green circle." />
                            <b className="pt-1 fw_800"><T>Premium</T></b>
                            <p className="text-center flex-grow-1 d-flex align-items-center"><T>Winner based on risk-adjusted returns</T></p>
                        </Col>
                    </Row>
                </Col>
            </Row>

            <Row className="mt-5 pt-5">
            <Col sm="7">
                    <Row>
                        <Col>
                            <h3><T>Information on Companies</T></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span><T>Participants get access to information on companies. This includes financial statements, descriptions, risk scores, and industry indicators.</T></span>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span><T>With this information and key figures, participants are given the opportunity to make decisions on an informed and insightful basis.</T></span>
                        </Col>
                    </Row>
                    <Row className="premium-double-img-container">
                        <Col sm="6" className="d-flex flex-column align-items-center mt-3 premium-single-img-container h-100" >
                            <img width="150px" height="150px" src="https://static.aktiedysten.dk/gfx/Billede8-150x150.png" alt="Graph showing a green upward trend line and a red downward trend line, with a stack of money below" />
                            <b className="pt-1 fw_800"><T>Standard</T></b>
                            <p className="text-center flex-grow-1 d-flex align-items-center"><T>Stock price development</T></p>
                        </Col>
                        <Col sm="6" className="d-flex flex-column align-items-center mt-3 premium-single-img-container h-100" >
                            <img width="150px" height="150px" src="https://static.aktiedysten.dk/gfx/9-300x300.png" alt="Magnifying glass inspecting a commercial building, indicating market analysis or due diligence" />
                            <b className="pt-1 fw_800"><T>Premium</T></b>
                            <p className="text-center flex-grow-1 d-flex align-items-center"><T>Stock price development, financial reports, descriptions, risk scores, and industry classification</T></p>
                        </Col>
                    </Row>
                </Col>
                <Col sm="5">
                    <img className="premium-rounded-corners premium-info-img" width="100%" height="100%" src="https://static.aktiedysten.dk/imgs/1-9-768x432.jpg" alt="A person looking at a laptop screen displaying a website with various company logos, including Spotify, CAT, Coca-Cola, Twitter, Tesla, and IBM" />
                </Col>
            </Row>

            <Row className="mt-5 pt-5">
                <Col sm="5">
                    <img className="premium-rounded-corners premium-info-img" width="100%" height="100%" src="https://static.aktiedysten.dk/imgs/Produkt-og-koncept-4-768x432.png" alt="Open laptop displaying a spreadsheet-like table with rows and columns of data.  The table shows various metrics, percentages, and possibly IDs.  A cup of cappuccino is visible on a table surface in the foreground" />
                </Col>
                <Col sm="7">
                    <Row>
                        <Col>
                            <h3><T>Manage the Participants in Your Challenge</T></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span><T>An open invitation link offers considerable freedom to attract many people to your challenges. However, it can also mean that a few participants might sneak in who aren’t affiliated with you or who don’t adhere to your established rules.</T></span>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <span><T>With Premium, you have the option to remove unwanted participants from your challenges.</T></span>
                        </Col>
                    </Row>
                    <Row className="premium-double-img-container">
                        <Col sm="6" className="d-flex flex-column align-items-center mt-3 premium-single-img-container h-100" >
                            <img width="150px" height="150px" src="https://static.aktiedysten.dk/gfx/Icons-2-300x300.png" alt='Open door with "Open" sign, indicating business hours or opportunity' />
                            <b className="pt-1 fw_800"><T>Standard</T></b>
                            <p className="text-center flex-grow-1 d-flex align-items-center"><T>No administration</T></p>
                        </Col>
                        <Col sm="6" className="d-flex flex-column align-items-center mt-3 premium-single-img-container h-100" >
                            <img width="150px" height="150px" src="https://static.aktiedysten.dk/gfx/Icons-300x300.png" alt="Female security guard standing at a stanchion rope" />
                            <b className="pt-1 fw_800"><T>Premium</T></b>
                            <p className="text-center flex-grow-1 d-flex align-items-center"><T>Remove unwanted participants</T></p>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumInfo.js